import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Spinner, 
} from "reactstrap"
import { Link } from "react-router-dom"
import { get } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import moment from "moment";

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';


const Vendor = props => {

  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState(null);

  const fetchData = () => {
    setLoading(true);
      console.log('RESP:');
      get(url.GET_CONTRACT+'/'+props.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setData(response.data);
        setLoading(false);
        }
      else {
        setData(null);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  React.useEffect(()=>{
    fetchData();
  }, []);


  return (
      <Modal isOpen={props.isOpen} toggle={props.toggle} size="lg" className="" centered>
        <ModalHeader toggle={props.toggle}>Contract Details</ModalHeader>
        <ModalBody>
            { loading ? 
            <div style={{textAlign: 'center'}}>
                <Spinner color="primary" />
            </div> 
            :
            <div>
                { data == null ? 
                <div className="text-muted">Contract could  not be loaded</div>
                :
                <div>
                  <table className="table table-striped">
                    <thead></thead>
                    <tbody>
                        <tr>
                            <td className="pb-4">Contract type</td>
                            <td className="pb-4">{data.contract_type}</td>
                        </tr>
                        <tr>
                            <td className="pb-4">Vendor</td>
                            <td className="pb-4">{data.vendor.name}</td>
                        </tr>
                        <tr>
                            <td className="pb-4">Start date</td>
                            <td className="pb-4">{moment(data.start_date).format('DD MMM YYYY')}</td>
                        </tr>
                        <tr>
                            <td className="pb-4">End date</td>
                            <td className="pb-4">{moment(data.end_date).format('DD MMM YYYY')}</td>
                        </tr>
                        <tr>
                            <td className="pb-4">Date created</td>
                            <td className="pb-4">{moment(data.created_at).format('DD MMM YYYY, hh:mm a')}</td>
                        </tr>
                    </tbody>
                  </table>
                  {data.assettype && 
                  <div>
                    <h5 className="h5 mt-5 mb-3">Asset type</h5>
                    <div>
                      {data.assettype?.name}
                    </div>
                  </div>
                  }
                  {data.assets.length > 0 && 
                  <div>
                    <h5 className="h5 mt-5 mb-3">Assets</h5>
                    {data.assets.map((asset, assetIdx) => (
                      <div key={assetIdx}>
                        {asset.name}
                      </div>
                    ))}
                  </div>
                  }
                  {data.contractlogs.length > 0 && 
                  <div>
                    <h5 className="h5 mt-5 mb-3">Edit History</h5>
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>User</th>
                          <th>Edited at</th>
                          <th>Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.contractlogs.map((log, logIdx) => (
                          <tr key={logIdx}>
                            <td>{log.user?.name}</td>
                            <td>{moment(log.created_at).format('DD MMM YYYY hh:mm a')}</td>
                            <td>{log.reason}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  }
                </div>
                }
            </div>
            }
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={props.toggle}>Close</Button>
          
        </ModalFooter>
      </Modal>
  )
}

export default Vendor
